import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import { Attention, CalendarEmpty, CalendarWarning } from '@bibliocommons/base-icons';

import BorrowingStatusIcon from '../../shared/BorrowingStatusIcon';

import './CheckedOutStatusIcon.scss';

const getIcon = (status) => {
  switch (status) {
    case 'OVERDUE':
      return <Attention />;
    case 'COMING_DUE':
      return <CalendarWarning />;
    default:
      return <CalendarEmpty />;
  }
};

export default function CheckedOutStatusIcon({ status, withBackground, withLabel }) {
  const label = (
    status && <FormattedMessage id={`checkedout_status_${status.toLowerCase()}`} />
  );

  return (
    <BorrowingStatusIcon
      className="cp-checked-out-status-icon"
      icon={getIcon(status)}
      status={status}
      withBackground={withBackground}
      renderLabel={withLabel && (() => label)} />
  );
}

CheckedOutStatusIcon.propTypes = {
  status: PropTypes.string.isRequired,
  withBackground: PropTypes.bool,
  withLabel: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/components/borrowing/checkouts/CheckedOutStatusIcon/CheckedOutStatusIcon.jsx